import React from 'react';
import { ChevronDown, ChevronRight, Loader2, CornerDownLeft, Trash2 } from 'lucide-react';

// Simplified Types for Props
type Lesson = {
  id: number;
  title: string;
  sort_order: number;
};

type Stage = {
  id: number;
  title: string;
  lessons?: Lesson[];
  isLoading?: boolean;
};

type Props = {
  stages: Stage[];
  expandedStageIds: number[];
  selectedLessonId: number | null;
  onToggleStage: (id: number) => void;
  onSelectLesson: (lesson: any) => void;
  onQuickInsert: (sId: number, lId: number, order: number) => void;
  onDeleteLesson: (sId: number, lId: number, order: number) => void;
};

export const CourseSidebar: React.FC<Props> = ({ 
  stages, expandedStageIds, selectedLessonId, 
  onToggleStage, onSelectLesson, onQuickInsert, onDeleteLesson 
}) => {
  return (
    <div className="w-[350px] bg-white border-r flex flex-col overflow-y-auto shrink-0">
      {stages.map(stage => (
        <div key={stage.id} className="border-b border-gray-100">
          <button onClick={() => onToggleStage(stage.id)} className="w-full flex items-center justify-between p-4 hover:bg-gray-50 text-left">
            <span className="font-semibold text-gray-700">{stage.title}</span>
            {expandedStageIds.includes(stage.id) ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
          </button>
          
          {expandedStageIds.includes(stage.id) && (
            <div className="bg-gray-50/50 pb-2">
              {stage.isLoading && <div className="flex justify-center p-2 text-gray-400"><Loader2 size={16} className="animate-spin" /></div>}
              {stage.lessons?.map(lesson => {
                const isSelected = selectedLessonId === lesson.id;
                return (
                  <div 
                    key={lesson.id} 
                    className={`group relative w-full flex items-center gap-3 px-6 py-3 text-sm transition-colors cursor-pointer ${isSelected ? 'bg-brand-50 text-brand-700 border-r-4 border-brand-500' : 'text-gray-600 hover:bg-gray-100'}`}
                    onClick={() => onSelectLesson(lesson)}
                  >
                    <span className="text-xs font-mono text-gray-400 w-6">{lesson.sort_order.toString().padStart(2, '0')}</span>
                    <span className="truncate text-left flex-1">{lesson.title}</span>
                    
                    {isSelected && (
                      <div className="absolute right-2 flex gap-1">
                        <button 
                          onClick={(e) => { e.stopPropagation(); onQuickInsert(stage.id, lesson.id, lesson.sort_order); }}
                          className="p-1 bg-white border border-gray-200 rounded shadow-sm text-gray-400 hover:text-blue-600 hover:border-blue-300 transition-all transform hover:scale-110"
                          title="Insert Below"
                        >
                          <CornerDownLeft size={14} />
                        </button>
                        <button 
                          onClick={(e) => { e.stopPropagation(); onDeleteLesson(stage.id, lesson.id, lesson.sort_order); }}
                          className="p-1 bg-white border border-gray-200 rounded shadow-sm text-gray-400 hover:text-red-600 hover:border-red-300 transition-all transform hover:scale-110"
                          title="Delete Lesson"
                        >
                          <Trash2 size={14} />
                        </button>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};
